import { QueryEntity } from "@datorama/akita";
import { BehaviorSubject } from "rxjs";
import { singleton } from "tsyringe";

import type TikTokPostEntity from "../entities/TikTokPostEntity";
import { TikTokPostsState, TikTokPostsStore } from "../stores/TikTokPostsStore";

@singleton()
export class TikTokPostsQuery extends QueryEntity<TikTokPostsState> {
    constructor(protected store: TikTokPostsStore) {
        super(store);
        this.active$ = new BehaviorSubject<TikTokPostEntity | undefined>(
            undefined
        );
        this.selectActive().subscribe(this.active$);
    }
    all$ = this.selectAll();
    paginationMeta$ = this.select((v) => v.paginationMeta);
    first$ = this.selectFirst();
    loading$ = this.selectLoading();
    error$ = this.selectError();
    active$: BehaviorSubject<TikTokPostEntity | undefined>;
}
